import React from 'react';
import { useTranslate } from '@hooks';
import { map } from 'lodash';
import { Row, Col, FormGroup } from 'reactstrap';
import { FormColumn as Form, Input, SubsectionTitle } from '@dotone/react-ui-core';

const AffiliateColumnForm = (props) => {
  const { t } = useTranslate('affiliate', 'model');
  const columns = {
    basic: ['categoryGroups', 'siteInfos', 'internalNotes'],
    metrics: ['networkPerformance', 'networkHistory'],
  };

  return (
    <Form {...props}>
      <Row>
        {map(columns, (items, group) => (
          <Col key={group} md={6} lg={3}>
            <SubsectionTitle tag="h6">{t(`affiliate:columnGroup.${group}`)}</SubsectionTitle>
            <FormGroup>
              {items.map((item) => (
                <Input key={item} name={`columns.${item}`} type="checkbox" label={t(item)} />
              ))}
            </FormGroup>
          </Col>
        ))}
      </Row>
    </Form>
  );
};

export default AffiliateColumnForm;
